export default async function RazorpayHandler({
  amount,
  data,
  onSuccessHandler,
  onErrorHandler,
}) {
  let ipAddress = null;
  try {
    const res = await fetch("/api/ip", { cache: "no-store" }); // Disable cache for fresh data
    const ipResponse = await res.json();
    // console.log("IP Response:", ipResponse);
    if (ipResponse.ip) {
      ipAddress = ipResponse.ip;
    }
  } catch (error) {
    console.error("Error fetching IP:", error);
  }

  const options = {
    // key: "rzp_test_TUXUeJU2DdF2Qg",
    key: process.env.NEXT_PUBLIC_RAZORPAY_ID, // Enter the Key ID generated from the Dashboard
    amount: parseInt(amount) * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    // "currency": "INR",
    name: data.eventData.subEventName,
    order_id: data.orderID,
    description: "Event Registration Fee", //data.description || "e-Dakshina",
    // invoice_id: "arnab_bhakta",
    // image:
    //   data.image ||
    //   "https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj",
    handler: onSuccessHandler,
    prefill: {
      name: data.userName || "",
      email: "utsav.upi@gmail.com",
      contact: data.contact || "",
    },
    notes: {
      //address: data.userAddress.address,
      contact: data.contact,
      registrationID: data.registrationID,
      uid: data.uid,
      eventID: data.eventData.eventID,
      subEventID: data.eventData.subEventID || null,
      source: data.source,
      language: data.language || "en",
      version: "v2",
      isDigital: "false",
      ipAddress: ipAddress
    },
    //customer_id:"nac_19776378673iu38989",
    // theme: {
    //   color: "#5e17eb",
    // },
    modal: {
      //escape: false,
      ondismiss: function () {
        //console.log("Checkout form closed");
        document.body.style.overflow = "auto";
      },
    },
  };
  // Razorpay init
  if (typeof Razorpay === "undefined") {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.id = "razorpay";
    script.onload = () => {
      const rzp = new Razorpay(options);
      rzp.open();
      rzp.on("payment.failed", () => {
        if (onErrorHandler) onErrorHandler();
      });
    };
    script.onerror = () => {
      if (onErrorHandler) onErrorHandler();
    };
    document.body.appendChild(script);
  } else {
    const rzp = new Razorpay(options);
    rzp.open();
    rzp.on("payment.failed", () => {
      if (onErrorHandler) onErrorHandler();
    });
  }
}
